export default __webpack_public_path__ + "static/brush-f095e59f6db6e86fda101b1a984291cd.png";